import type { EngagementSurveyQuestionChartData, EngagementSurveyQuestionChartDataRow } from "./types";

export const getEngagementSurveyQuestionChartDataRows = (
  data: EngagementSurveyQuestionChartData
): EngagementSurveyQuestionChartDataRow[] => {
  return data.slice(1) as EngagementSurveyQuestionChartDataRow[];
};
